import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.css'
import reportWebVitals from "./reportWebVitals";
import {ChakraProvider, defaultSystem} from "@chakra-ui/react";

ReactDOM.createRoot(document.getElementById('root')).render(
    <ChakraProvider value={defaultSystem}>
        <App />
    </ChakraProvider>)
reportWebVitals();
